import { getStore } from '~/mobx/AppStore';
import { showMessageModal } from '~/clientUtils/showMessageModal';
import companyApi from '~/clientApis/companyApi';
import { isEmpty } from 'lodash';
import { Election } from '~/definitions/election';
import { CategoryWithChildrenResponse } from '@bluestone-node-sdk/pim';

// Resets all relevant stores when no election is found
const resetStoresOnEmptyElection = () => {
    const { adminStore, regionStore, generalSettingsStore } = getStore();

    adminStore.setElection(null);
    adminStore.setElectionToCopy(null);
    adminStore.setAttributesState([]);
    adminStore.setValidationErrors({});
    regionStore.setRegions([]);
    generalSettingsStore.setSelectedElectionId('');
    generalSettingsStore.setSelectedElectionData({});
    generalSettingsStore.setElectionList([]);
};

// Updates all relevant stores with fetched election data
const updateStoresWithElectionData = (election: CategoryWithChildrenResponse, electionList: Election[]) => {
    const { adminStore, regionStore, generalSettingsStore } = getStore();

    const attributes = (election as Election)?.attributes || [];
    const electionId = election.id || '';

    adminStore.setElection(election);
    adminStore.setElectionToCopy(election);
    adminStore.setValidationErrors({});
    regionStore.setRegions(election?.children || []);
    adminStore.setAttributesState(attributes);
    generalSettingsStore.setSelectedElectionId(electionId);
    generalSettingsStore.setSelectedElectionData(election);
    generalSettingsStore.setElectionList(electionList);
};

export const fetchElectionAndRegions = async (id: string): Promise<void> => {
    const { adminStore, generalSettingsStore } = getStore();

    adminStore.setIsLoadingElectionAndRegions(true);

    try {
        // Fetch the election object (with its regions) from the API
        const selectedElectionId = generalSettingsStore.isSettingsDisabled
            ? generalSettingsStore.selectedElectionId
            : '';
        const result = await companyApi.getElectionByCompanyId(id, {
            electionId: selectedElectionId,
        });

        const election = result?.election;
        const electionList = result?.electionList || [];

        if (isEmpty(election)) {
            resetStoresOnEmptyElection();
            return;
        }
        updateStoresWithElectionData(election, electionList);
    } catch {
        showMessageModal('error', 'Failed to fetch election and regions');
    } finally {
        adminStore.setIsLoadingElectionAndRegions(false);
    }
};
